/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-12-05 11:39:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import RuleGroupItem from './rule-group-item';
import SelectProductModal from 'src/components/containers/recommendation/widget/item/general/select-product-modal';

import {
  RECOMMENDATION_WIDGET_LIMIT_RULE_GROUPS as LIMIT_RULE_GROUPS,
  RECOMMENDATION_WIDGET_LIMIT_CONDITION_PRODUCTS_PER_RULE as LIMIT_CONDITION_PRODUCTS,
  RECOMMENDATION_WIDGET_LIMIT_CONSEQUENCE_PRODUCTS_PER_RULE as LIMIT_CONSEQUENCE_PRODUCTS
} from 'src/constants/recommendation';

import type { RuleGroupListType } from 'src/models/recommendation';

type Props = {
  rules: RuleGroupListType,
  pageType: string,
  updateRulesField: Function,
  collections: Array<{ value: string, label: string }>
};

type ComposedProps = WithI18nProps & Props;

class RuleGroupList extends Component<ComposedProps> {
  state = {
    selectedIndex: -1,
    activeSelectConditionProducts: false,
    activeSelectConsequenceProducts: false
  };

  render() {
    const { selectedIndex, activeSelectConditionProducts, activeSelectConsequenceProducts } =
      this.state;
    const { i18n, rules, updateRulesField, pageType, collections } = this.props;
    const isLimitRuleGroups = rules.length >= LIMIT_RULE_GROUPS;
    return (
      <div>
        {rules.map((rule, index) => (
          <RuleGroupItem
            rules={rules}
            rule={rule}
            key={index}
            index={index}
            updateRulesField={updateRulesField}
            toggleModal={this.toggleModal}
            pageType={pageType}
            collections={collections}
          />
        ))}
        {!(isLimitRuleGroups || ['home-page', 'cart-page'].includes(pageType)) && (
          <div style={{ marginTop: '0.75rem' }}>
            <Button size="slim" onClick={this.addNewGroup}>
              {i18n.translate('AdminHTML.Recommendation.WidgetItem.addNewGroup')}
            </Button>
          </div>
        )}

        <SelectProductModal
          active={activeSelectConditionProducts}
          toggleModal={() => this.toggleModal('activeSelectConditionProducts', -1)}
          limitSelection={LIMIT_CONDITION_PRODUCTS}
          fieldName="conditions"
          selectedIndex={selectedIndex}
          selectedProducts={rules[selectedIndex]?.conditions[0]?.value || []}
          rules={rules}
          updateRulesField={updateRulesField}
        />

        <SelectProductModal
          active={activeSelectConsequenceProducts}
          toggleModal={() => this.toggleModal('activeSelectConsequenceProducts', -1)}
          limitSelection={LIMIT_CONSEQUENCE_PRODUCTS}
          fieldName="consequences"
          selectedIndex={selectedIndex}
          selectedProducts={rules[selectedIndex]?.consequences[0]?.value || []}
          rules={rules}
          updateRulesField={updateRulesField}
        />
      </div>
    );
  }

  // Handle toggle modal
  toggleModal = (name: string, index: number) => {
    this.setState({ selectedIndex: index, [name]: !this.state[name] });
  };

  // Handle add new group action
  addNewGroup = () => {
    const { rules, updateRulesField } = this.props;

    let clonedRules = _.cloneDeep(rules);

    clonedRules.push({
      conditions: [{ option: 'productId', value: [] }],
      consequences: [{ option: 'productId', value: [] }]
    });
    updateRulesField(clonedRules);
  };
}

export default withI18n()(RuleGroupList);
